import { unwrapResult } from '@reduxjs/toolkit';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchAuthenticatedUserDetails } from '~/components/Auth';
import { authStoreStateSelector } from '~/selectors';
import { AppDispatch } from '~/store';

export const useAuthentication = () => {
  const dispatch: AppDispatch = useDispatch();
  const { userDetails } = useSelector(authStoreStateSelector);
  const [failToLoad, setFailToLoad] = useState(false);
  const isAuthenticated = useMemo(() => !!userDetails, [userDetails]);

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(fetchAuthenticatedUserDetails())
        .then(unwrapResult)
        .catch(() => {
          setFailToLoad(true);
        });
    }
  }, [isAuthenticated, dispatch]);

  return {
    userDetails,
    isAuthenticated,
    failToLoad,
  };
};
